export const CREATE = 'CREATE';
export const VIEW = 'VIEW';
export const MANAGE = 'MANAGE';
